import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledAreaDevelopment = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  & section {
    width: 99%;
  }

  & .content-container {
    height: calc(100dvh - 216px);
    overflow-y: auto;
    padding: 24px;
  }

  & .small-input {
    max-width: 278px;
    min-width: 20%;
  }

  & .footer {
    display: flex;
    align-items: center;
    justify-content: end;

    height: 80px;
    border-top: 1px solid ${theme.colors.purple_2};
    padding: 0 20px;
  }
  & .footer-items {
    display: flex;
    flex-direction: row;
    justify-content: end;
  }
`;
